

const days =["Mon", "Tue", "Wed", "Thu", "Fri", "Sat","Sun"];

export default days;